import { OrderSide } from "../../../data/models";

export const renderOrderIndSide = (rowData: any) => {

	console.log(rowData)
	switch (rowData.side) {
		case OrderSide.Buy:
		case "BUY":
			return "KUPI";

		case OrderSide.Sell:
		case "SELL":
			return "PRODAJ";

		default:
			return rowData.side;
	}
};